// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_ix","advertCardNum":"c-a_iy"};